import React from 'react';
import ReactDOM from 'react-dom';

const renderRootComponent = (elementId = 'root') => {
    const RootComponent = engine.rootComponent;
    ReactDOM.render(<RootComponent />, document.getElementById(elementId));
};

export default renderRootComponent;
